// NotificationRefetchContext.tsx
import {createContext, ReactNode, useContext, useState} from 'react'

type RefetchFn = (() => void) | null

const HomeNotificationRefetchContext = createContext<{
  setRefetch: (fn: () => void) => void
  refetch: () => void
}>({
  setRefetch: () => {},
  refetch: () => {},
})

export const HomeNotificationRefetchProvider = ({children}: {children: ReactNode}) => {
  const [refetchFn, setRefetchFn] = useState<RefetchFn>(null)

  const setRefetch = (fn: () => void) => setRefetchFn(() => fn)
  const refetch = () => {
    if (refetchFn) refetchFn()
  }

  return (
    <HomeNotificationRefetchContext.Provider value={{setRefetch, refetch}} /* NOSONAR */>
      {children}
    </HomeNotificationRefetchContext.Provider>
  )
}

export const useNotificationRefetch = () => useContext(HomeNotificationRefetchContext)
